module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_22.64fda1e9.pdf";